<template>
  <div>
    <div class="login-bg">
      <b-row>
        <b-col md="6" lg="4" data-aos="fade-right" class="left-side">
          <b-form @submit.prevent="onSubmit" id="form-login">
            <div class="icon-container">
<!--              <img src="../../public/logo-ub.png" alt="logo" srcset="" /> -->
	<img src="../../public/logoComplement.jpg" alt="" srcset="">
            </div>
            <div class="content">
              <h3>{{ labels.greeting }}</h3>
              <p>{{ labels.info }}</p>
              <p v-if="error" class="invalid-login">{{ errorMessage }}</p>
            </div>
            <b-form-group :class="{ formLoading: isLoading }">
              <md-field v-if="!mfaStep">
                <label>{{ labels.email }}</label>
                <span><font-awesome-icon :icon="['fas', 'envelope']"/></span>
                <md-input
                  type="text"
                  name="email"
                  v-model="form.email"
                  :placeholder="labels.email"
                  required
                />
              </md-field>
              <md-field v-if="!mfaStep">
                <label>{{ labels.password }}</label>
                <span><font-awesome-icon :icon="['fas', 'lock']"/></span>
                <md-input
                  type="password"
                  name="password"
                  v-model="form.password"
                  :placeholder="labels.password"
                  required
                />
              </md-field>
              <md-field v-if="mfaStep">
                <label>{{ labels.code }}</label>
                <span><font-awesome-icon :icon="['fas', 'lock']"/></span>
                <md-input
                  type="text"
                  name="mfa_code"
                  v-model="mfaCode"
                  :placeholder="labels.code"
                  maxlength="6"
                  required
                />
              </md-field>
              <b-button type="submit" id="login-btn">{{
                mfaStep ? labels.verify : labels.login
              }}</b-button>     
              <div v-if="mfaStep" class="forgot-password" @click="resendMfaCode()">{{ labels.resendCode }}</div>
              <div v-if="mfaStep" class="forgot-password" @click="resetLoginFlow()">{{ labels.changeUser }}</div>
              <div class="forgot-password" @click="openResetDialog()">{{ labels.forgot }}</div>
              <div class="more">
                <!-- <a href="#" @click.prevent="changeLanguage()" class="forgot">{{
                labels.forgot
              }}</a> -->
              <a href="#" @click.prevent="changeLanguage()" class="lang">{{
                labels.lang
              }}</a>
              </div>         
            </b-form-group>
            
            <div class="loadingSpinner" :class="{ active: isLoading }">
              <b-spinner></b-spinner>
            </div>
          </b-form>
        </b-col>
        <b-col md="6" lg="8" data-aos="fade-left" class="right-side">
          <img src="../../public/logoComplement.jpg" alt="" srcset="">
          <h3>{{labels.tittleImg}}</h3>
        </b-col>
      </b-row>
    </div>
    <div v-if="mfaSuccessLoading" class="mfa-loading-overlay">
      <div class="mfa-loading-card">
        <b-spinner></b-spinner>
        <p>{{ labels.mfaLoading }}</p>
      </div>
    </div>
    <!-- <loader id="pre-loader" object="#21dec7" color1="#884af4" color2="#f28c44" size="5" speed="1.5" bg="#000000" objectbg="#999793" opacity="70" name="circular"></loader> -->
    <md-dialog v-if="showDialog" :md-active.sync="showDialog" class="reset-password-dialog">
      <md-dialog-title class="reset-dialog-title">{{ labels.resetTitle }}</md-dialog-title>
      <md-dialog-content class="reset-dialog-content">
        <div class="reset-step-chip">{{ resetStepLabel }}</div>
        <p class="reset-dialog-subtitle">{{ resetSubtitle }}</p>
        <p v-if="resetError" class="invalid-login">{{ resetError }}</p>

        <md-field v-if="resetStep === 1">
          <md-input v-model="resetForm.email" type="email" :placeholder="labels.resetEmailLabel" />
        </md-field>

        <md-field v-if="resetStep === 2">
          <md-input v-model="resetForm.code" maxlength="6" :placeholder="labels.resetCodeLabel" />
        </md-field>
        <div v-if="resetStep === 2" class="reset-action-link" @click="resendResetCode()">{{ labels.resendCode }}</div>

        <md-field v-if="resetStep === 3">
          <md-input v-model="resetForm.password" type="password" :placeholder="labels.newPassword" />
        </md-field>
        <md-field v-if="resetStep === 3">
          <md-input v-model="resetForm.confirmPassword" type="password" :placeholder="labels.confirmPassword" />
        </md-field>
        <div v-if="resetStep === 3" class="password-policy-box">
          <div class="password-policy-title">{{ labels.passwordPolicyTitle }}</div>
          <div class="password-policy-item">{{ labels.policyLength }}: {{ passwordPolicy.minLength }} - {{ passwordPolicy.maxLength }}</div>
          <div v-if="passwordPolicy.requireUppercase" class="password-policy-item">{{ labels.policyUppercase }}</div>
          <div v-if="passwordPolicy.requireLowercase" class="password-policy-item">{{ labels.policyLowercase }}</div>
          <div v-if="passwordPolicy.requireNumber" class="password-policy-item">{{ labels.policyNumber }}</div>
          <div v-if="passwordPolicy.requireSpecial" class="password-policy-item">{{ labels.policySpecial }}</div>
        </div>
      </md-dialog-content>
      <md-dialog-actions class="reset-dialog-actions">
        <md-button class="md-accent" @click="closeResetDialog()">{{ labels.close }}</md-button>
        <md-button class="md-primary" @click="handleResetAction()" :disabled="resetLoading">
          {{ resetPrimaryButtonLabel }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import Auth from "@/services/Authentication";

export default {
  data: () => ({
    form: {
      email: "",
      password: "",
    },
    showDialog: false,
    isLoading: false,
    error: false,
    errorMessage: "",
    isFetching: true,
    resetLoading: false,
    resetStep: 1,
    resetError: "",
    resetForm: {
      email: "",
      resetToken: "",
      code: "",
      password: "",
      confirmPassword: "",
    },
    passwordPolicy: {
      minLength: 8,
      maxLength: 20,
      requireUppercase: true,
      requireLowercase: true,
      requireNumber: true,
      requireSpecial: true,
    },
    mfaStep: false,
    mfaToken: "",
    mfaCode: "",
    mfaSuccessLoading: false,
  }),
  methods: {
    onSubmit() {
      if (this.mfaStep) {
        this.verifyMfaCode();
        return;
      }

      this.error = false;
      this.errorMessage = "";
      this.isLoading = true;
      let nextRoute = "";
      Auth.login(this.form)
        .then((user) => {
          if (user.data.requiresMfa) {
            this.mfaStep = true;
            this.mfaToken = user.data.mfaToken;
            this.mfaCode = "";
            this.$toast.info("Te enviamos un codigo a tu correo");
            return;
          }

          user.data.isAuthenticated = true;
          this.$store.commit("setData", user.data);
          
          if(user.data.isAuthenticated){
            nextRoute = {name: 'home'};
          }
        })
        .catch(() => {
          this.error = true;
          this.errorMessage = this.labels.err;
        })
        .finally(() => {
          this.isLoading = false;
          if (nextRoute.name) {
            this.$router.push(nextRoute);
          }
        });
    },
    verifyMfaCode() {
      this.error = false;
      this.errorMessage = "";
      this.isLoading = true;
      let nextRoute = "";

      Auth.verifyMfa({ mfaToken: this.mfaToken, code: this.mfaCode })
        .then((user) => {
          user.data.isAuthenticated = true;
          this.$store.commit("setData", user.data);
          if (user.data.isAuthenticated) {
            this.mfaSuccessLoading = true;
            nextRoute = { name: "home" };
          }
        })
        .catch((err) => {
          this.error = true;
          this.errorMessage = this.labels.errCode;
          if (err.response && err.response.data && err.response.data.message) {
            this.$toast.error(err.response.data.message);
          }
        })
        .finally(() => {
          this.isLoading = false;
          if (nextRoute.name) {
            setTimeout(() => {
              this.mfaSuccessLoading = false;
              this.$router.push(nextRoute);
            }, 900);
          }
        });
    },
    resendMfaCode() {
      this.isLoading = true;
      Auth.resendMfa({ mfaToken: this.mfaToken })
        .then(() => {
          this.$toast.success("Codigo reenviado al correo");
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.$toast.error(err.response.data.message);
          } else {
            this.$toast.error("No fue posible reenviar el codigo");
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetLoginFlow() {
      this.mfaStep = false;
      this.mfaToken = "";
      this.mfaCode = "";
    },
    changeLanguage() {
      this.isLoading = true;
      if (this.$store.state._language == "en-US") {
        this.$store.commit("setLang", "es-ES");
      } else {
        this.$store.commit("setLang", "en-US");
      }
      this.isLoading = false;
    },
    openResetDialog() {
      this.loadPasswordPolicy();
      this.showDialog = true;
      this.resetStep = 1;
      this.resetError = "";
      this.resetLoading = false;
      this.resetForm = {
        email: "",
        resetToken: "",
        code: "",
        password: "",
        confirmPassword: "",
      };
    },
    closeResetDialog() {
      this.showDialog = false;
      this.resetLoading = false;
      this.resetError = "";
    },
    handleResetAction() {
      if (this.resetStep === 1) {
        this.requestResetCode();
        return;
      }
      if (this.resetStep === 2) {
        this.verifyResetCode();
        return;
      }
      this.confirmResetPassword();
    },
    requestResetCode() {
      this.resetError = "";
      if (!this.resetForm.email) {
        this.resetError = this.labels.resetEmailRequired;
        return;
      }

      this.resetLoading = true;
      Auth.requestPasswordResetCode({ email: this.resetForm.email })
        .then((response) => {
          this.resetForm.resetToken = response.data.resetToken;
          this.resetStep = 2;
          this.$toast.success(this.labels.resetCodeSent);
        })
        .catch((err) => {
          this.resetError = (err.response && err.response.data && err.response.data.message) || this.labels.genericError;
        })
        .finally(() => {
          this.resetLoading = false;
        });
    },
    resendResetCode() {
      if (!this.resetForm.email) {
        this.resetError = this.labels.resetEmailRequired;
        return;
      }
      this.requestResetCode();
    },
    verifyResetCode() {
      this.resetError = "";
      if (!this.resetForm.code) {
        this.resetError = this.labels.resetCodeRequired;
        return;
      }

      this.resetLoading = true;
      Auth.verifyPasswordResetCode({
        resetToken: this.resetForm.resetToken,
        code: this.resetForm.code,
      })
        .then(() => {
          this.resetStep = 3;
          this.$toast.success(this.labels.resetCodeVerified);
        })
        .catch((err) => {
          this.resetError = (err.response && err.response.data && err.response.data.message) || this.labels.genericError;
        })
        .finally(() => {
          this.resetLoading = false;
        });
    },
    confirmResetPassword() {
      this.resetError = "";
      if (!this.resetForm.password || !this.resetForm.confirmPassword) {
        this.resetError = this.labels.resetPasswordRequired;
        return;
      }
      if (this.resetForm.password !== this.resetForm.confirmPassword) {
        this.resetError = this.labels.resetPasswordsNoMatch;
        return;
      }
      const policyErrors = this.validatePasswordByPolicy(this.resetForm.password);
      if (policyErrors.length) {
        this.resetError = policyErrors[0];
        return;
      }

      this.resetLoading = true;
      Auth.confirmPasswordReset({
        resetToken: this.resetForm.resetToken,
        password: this.resetForm.password,
        confirmPassword: this.resetForm.confirmPassword,
      })
        .then(() => {
          this.$toast.success(this.labels.resetSuccess);
          this.closeResetDialog();
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.details && err.response.data.details.length) {
            this.resetError = err.response.data.details[0];
            return;
          }
          this.resetError = (err.response && err.response.data && err.response.data.message) || this.labels.genericError;
        })
        .finally(() => {
          this.resetLoading = false;
        });
    },
    loadPasswordPolicy() {
      Auth.getPasswordPolicy()
        .then((response) => {
          if (response.data && response.data.policy) {
            this.passwordPolicy = response.data.policy;
          }
        })
        .catch(() => {});
    },
    validatePasswordByPolicy(password) {
      const errors = [];
      const p = this.passwordPolicy;

      if (password.length < p.minLength) {
        errors.push(`${this.labels.policyLength}: ${p.minLength} - ${p.maxLength}`);
      }
      if (password.length > p.maxLength) {
        errors.push(`${this.labels.policyLength}: ${p.minLength} - ${p.maxLength}`);
      }
      if (p.requireUppercase && !/[A-Z]/.test(password)) {
        errors.push(this.labels.policyUppercase);
      }
      if (p.requireLowercase && !/[a-z]/.test(password)) {
        errors.push(this.labels.policyLowercase);
      }
      if (p.requireNumber && !/[0-9]/.test(password)) {
        errors.push(this.labels.policyNumber);
      }
      if (p.requireSpecial && !/[^A-Za-z0-9]/.test(password)) {
        errors.push(this.labels.policySpecial);
      }

      return errors;
    }
  },
  beforeMount(){
    if(this.$store.state.isAuthenticated){
      let nextRoute = "";
    switch(this.$store.state.userRole){
          case 'ADM':
            nextRoute = {name: 'home'};
            break;
          case 'COM':
            nextRoute = {name: 'home'};
            break;
          case 'APP':
            nextRoute = {name: 'list'};
            break;
          case 'CHK':
            nextRoute = {name: 'list'};
            break;
          case 'AGN':
            nextRoute = {name: 'pending'};
            break;
        }
          this.$router.push(nextRoute);

    }
  },
  computed: {
    resetStepLabel(){
      if (this.resetStep === 1) return this.labels.resetStep1;
      if (this.resetStep === 2) return this.labels.resetStep2;
      return this.labels.resetStep3;
    },
    resetSubtitle(){
      if (this.resetStep === 1) return this.labels.resetSubtitle1;
      if (this.resetStep === 2) return this.labels.resetSubtitle2;
      return this.labels.resetSubtitle3;
    },
    resetPrimaryButtonLabel(){
      if (this.resetStep === 1) return this.labels.sendCode;
      if (this.resetStep === 2) return this.labels.verify;
      return this.labels.updatePassword;
    },
    labels(){
    if (this.$store.state._language == "es-ES") {
      return {
        greeting: "Iniciar Sesión",
        info: "Ingresa los datos que utilizaste para el registro",
        email: "Correo Electrónico",
        password: "Contraseña",
        code: "Codigo de verificacion",
        login: "Ingresar",
        verify: "Verificar codigo",
        mfaLoading: "Verificando acceso...",
        resendCode: "Reenviar codigo",
        changeUser: "Cambiar usuario",
        lang: "English Version",
        err: "Credenciales Incorrectas",
        errCode: "Codigo Incorrecto",
        forgot: "Olvidé mi contraseña",
        close: "Cerrar",
        genericError: "Algo pasó, intentalo de nuevo",
        resetTitle: "Restablecer contraseña",
        resetStep1: "Paso 1 de 3",
        resetStep2: "Paso 2 de 3",
        resetStep3: "Paso 3 de 3",
        resetSubtitle1: "Ingresa tu correo para recibir un codigo de seguridad.",
        resetSubtitle2: "Revisa tu correo e ingresa el codigo que te enviamos.",
        resetSubtitle3: "Define una nueva contraseña para tu cuenta.",
        resetEmailLabel: "Correo electrónico",
        resetCodeLabel: "Codigo de verificacion",
        sendCode: "Enviar codigo",
        resetCodeSent: "Codigo enviado al correo",
        resetCodeRequired: "Debes ingresar el codigo",
        resetCodeVerified: "Codigo verificado",
        resetEmailRequired: "Debes ingresar un correo",
        newPassword: "Nueva contraseña",
        confirmPassword: "Confirmar contraseña",
        updatePassword: "Actualizar contraseña",
        passwordPolicyTitle: "Requisitos de contraseña",
        policyLength: "Longitud",
        policyUppercase: "Debe incluir al menos una mayúscula",
        policyLowercase: "Debe incluir al menos una minúscula",
        policyNumber: "Debe incluir al menos un número",
        policySpecial: "Debe incluir al menos un caracter especial",
        resetPasswordRequired: "Debes completar ambos campos de contraseña",
        resetPasswordsNoMatch: "Las contraseñas no coinciden",
        resetSuccess: "Contraseña actualizada correctamente",
        sentence: "Control de Facturas de Proveedores",
        tittleImg: "Herramienta para la Consolidación de los Estados Financieros de los Grupos Económicos",
      };
    } else {
      return  {
        greeting: "Login",
        info: "Fill the fields with the registration information you provide",
        email: "E-mail Address",
        password: "Password",
        code: "Verification code",
        login: "Login",
        verify: "Verify code",
        mfaLoading: "Verifying access...",
        resendCode: "Resend code",
        changeUser: "Change user",
        lang: "Versión en Español",
        err: "Invalid Credentials",
        errCode: "Invalid Code",
        forgot: "Forgot my password",
        close: "Close",
        genericError: "Something went wrong, please try again",
        resetTitle: "Reset password",
        resetStep1: "Step 1 of 3",
        resetStep2: "Step 2 of 3",
        resetStep3: "Step 3 of 3",
        resetSubtitle1: "Enter your email to receive a security code.",
        resetSubtitle2: "Check your email and enter the code we sent.",
        resetSubtitle3: "Set a new password for your account.",
        resetEmailLabel: "Email",
        resetCodeLabel: "Verification code",
        sendCode: "Send code",
        resetCodeSent: "Code sent to email",
        resetCodeRequired: "You must enter the code",
        resetCodeVerified: "Code verified",
        resetEmailRequired: "You must enter an email",
        newPassword: "New password",
        confirmPassword: "Confirm password",
        updatePassword: "Update password",
        passwordPolicyTitle: "Password requirements",
        policyLength: "Length",
        policyUppercase: "Must include at least one uppercase letter",
        policyLowercase: "Must include at least one lowercase letter",
        policyNumber: "Must include at least one number",
        policySpecial: "Must include at least one special character",
        resetPasswordRequired: "You must complete both password fields",
        resetPasswordsNoMatch: "Passwords do not match",
        resetSuccess: "Password updated successfully",
        sentence: "Start to improve your business financial operations",
        tittleImg: "Tool for conciliation of states financiers of an economic group"
      };
    }
    }
  },
};
</script>

<style src="./main.css"></style>
